/**
 * @file Custom React hooks
 */

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

/**
 *
 * @returns General hook for checking if the screen is currently what we define a "large"
 * That means: we display input and outputs in the Xs defined positions
 */
export function useLargeScreen() {
  const theme = useTheme();
  const largeScreen = useMediaQuery(`(min-width:${theme.custom.verticalLayoutBreakpoint}px)`);
  return largeScreen;
}
